import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";
import moment from "moment";
import constants from "@tracking/utils/constants";
const { DATE_FORMAT } = constants;

export const getDataCrlMatrizDecisao = createAsyncThunk(
  "crlApp/matriz/getDataCrlMatrizDecisao",
  async (paramsUrlValue: string | null, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/crl/matriz-decisao");
      if (paramsUrlValue) {
        dispatch(
          getDataCrlMatrizDecisaoByFilters({
            situacaoMatrizDecisao: [
              {
                name: `${paramsUrlValue}\u200B`,
              },
            ],
          })
        );
      }
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const getDataCrlMatrizDecisaoByFilters = createAsyncThunk(
  "crlApp/matriz/getDataCrlMatrizDecisaoByFilters",
  async (data: any, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/crl/matriz-decisao", {
        params: data,
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const getDataCrlMatrizDecisaoIndicadores = createAsyncThunk(
  "crlApp/matriz/getDataCrlMatrizDecisaoIndicadores",
  async (_, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get(
        `/indicador-diario?dataAtual=${moment().format(DATE_FORMAT.API)}`
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    dispatch(closeLoading());
    return response.data;
  }
);
